import type { FC } from 'react'
import React, { memo } from 'react'
import { useIntl } from 'react-intl'
import classNames from 'classnames'
import { InjectHtml } from '@/components/ui'
import { useBlockIntersection } from '@/utils/hooks'
import { setCounterAnimation } from '@/utils/hooks/animation/helpers'
import type { ILandingDetailProps, ILandingDetailsProps } from './interfaces'
import './styles.scss'

const LandingDetailOld: FC<ILandingDetailProps> = memo(({ isDetailsBlockIntersected, order, signId, valueId }) => {
  const { formatMessage } = useIntl()

  return (
    <div
      className="signed-detail-banner color_white"
      ref={isDetailsBlockIntersected === 'true' || !isDetailsBlockIntersected ? setCounterAnimation : undefined}
    >
      <h3 className={classNames('space-holder4-sm', { 'signed-detail-banner__title': !signId })}>
        <InjectHtml textId={valueId} />
      </h3>
      {signId && (
        <div className="space-holder8-from-sm signed-detail-banner__sign" fade-in-up={isDetailsBlockIntersected} animation-order={order}>
          {formatMessage({ id: signId })}
        </div>
      )}
    </div>
  )
})

export const LandingDetailsOld: FC<ILandingDetailsProps> = memo(({ details }) => {
  const { blockRef: detailsBlockRef, isBlockIntersected: isDetailsBlockIntersected } = useBlockIntersection()

  return (
    <div className="signed-details-banner" ref={detailsBlockRef}>
      <div
        className={classNames(
          'signed-details-banner-wrapper',
          { 'signed-details-banner-wrapper-sections_3': details.length === 3 },
          'page-wrapper row-align_center row-justify_between-sm',
        )}
      >
        {details.map(({ value, sign }, index) => {
          return (
            <LandingDetailOld
              signId={sign}
              valueId={value}
              order={index}
              key={index}
              isDetailsBlockIntersected={isDetailsBlockIntersected}
            />
          )
        })}
      </div>
    </div>
  )
})
